import { Center, Stack, Text } from "@mantine/core";
import { FaArrowDown } from "react-icons/fa";
import { FC } from "react";

interface ScrollToBottomButtonProps {
  scrollToBottom: (auto: boolean) => void;
}

const ScrollToBottomButton: FC<ScrollToBottomButtonProps> = ({
  scrollToBottom,
}) => {
  return (
    <Center>
      <Stack
        onClick={() => scrollToBottom(false)}
        align="center"
        style={{
          position: "absolute",
          bottom: "10px",
        }}
        className="scroll-to-bottom"
      >
        <Text>Scroll to Bottom</Text>
        <FaArrowDown />
      </Stack>
    </Center>
  );
};

export default ScrollToBottomButton;
